module.exports = function ($potentialModules) {
    var collapsableModules = [
        'paragraph',
        //'features-by-column',
        //'button-module',
        //'quote',
        //'campaign-listing',
        //'insights-collection-by-tag-selection',
        //'featured-topic-list',
        //'related-insights',
        //'client-story-grid',
        //'large-image',
        //'careers-persona-detail-body-description',
        //'universal-promo-module',
        'topic-landing',
        'tag-landing-page',
        'page-section-header--hidden',
        'featured-content-module'
    ];

    for (var i = 0; i < $potentialModules.length - 1; ++i) {
        var $currentModule = $($potentialModules[i]).first();
        var $nextModule = $($potentialModules[i + 1]).first();

        // make sure each module is in the list of accepted modules
        var currentModuleClassList = $currentModule[0].classList.value.split(' ');
        var nextModuleClassList = $nextModule[0].classList.value.split(' ');
        var currentMatchingClass, nextMatchingClass;
        var isCurrentInList = false;
        var isNextInList = false;

        for (var j = 0; j < collapsableModules.length; ++j) {
            var currentClass = collapsableModules[j];

            var currentClassIndex = currentModuleClassList.indexOf(currentClass);
            var nextClassIndex = nextModuleClassList.indexOf(currentClass);

            if (currentClassIndex !== -1) {
                isCurrentInList = true;
                currentMatchingClass = currentModuleClassList[j];
            }

            if (nextClassIndex !== -1) {
                isNextInList = true;
                nextMatchingClass = currentModuleClassList[j];
            }

            if (isCurrentInList && isNextInList) {
                break;
            }
        }

        if (isCurrentInList && isNextInList) {
            var currentBackgroundColor = $currentModule.css('background-color');
            var nextBackgroundColor = $nextModule.css('background-color');

            var currentBackgroundImage = $currentModule.css('background-image');
            var nextBackgroundImage = $currentModule.css('background-image');

            if (currentBackgroundColor === nextBackgroundColor && currentBackgroundImage === 'none' && nextBackgroundImage === 'none') {
                if ($currentModule.hasClass('page-section-header--hidden')) {
                    if ($currentModule.hasClass('collapse-space')) {
                        $nextModule.addClass('collapse-space');
                    }
                }
                else {
                    $nextModule.addClass('collapse-space');
                }
            }
        }
    }
};  